import React, { useState } from "react";

import { Icon, Image, Popup, Transition } from "semantic-ui-react";

import { ActionType, Hero, Player, TierConverter } from "../types";

import { getHeroImage } from "draft/heroes/useHeroes";
import { useMeleeContext } from "draft/context/MeleeContextProvider";

interface Props {
  hero: Hero;
  executeAction: any;
  applyHeroAction: any;
}

export default function FFAHeroImage(
  { hero, executeAction, applyHeroAction }: Props,
) {
  const meleeContext = useMeleeContext();
  const [shakeAnimation, setShakeAnimation] = useState(true);

  if (!meleeContext) return <></>;

  const getPlayerWhoClicks = (): Player => {
    var tempPlayer = meleeContext.gameData.Players.find((p) =>
      p.Number === meleeContext.gameData.CurrentAction?.PlayerNumber
    );
    if (!tempPlayer) {
      throw new Error("Something wrong - can't find triggering player");
    }
    return tempPlayer;
  };

  const banHero = () => {
    var banningPlayer = getPlayerWhoClicks();
    applyHeroAction(banningPlayer, hero, ActionType.Ban);
    executeAction();
  };

  const pickHero = () => {
    var pickingPlayer = getPlayerWhoClicks();
    applyHeroAction(pickingPlayer, hero, ActionType.Pick);
    executeAction();
  };

  function OnClick() {
    const currentAction = meleeContext?.gameData.CurrentAction;
    if (!currentAction) return;

    if (hero.Banned || hero.Picked) {
      setShakeAnimation(!shakeAnimation); //Spiller shake animation
      return;
    }

    if (meleeContext?.gameData.CurrentAction?.Action === ActionType.Ban) {
      banHero();
      return;
    }

    if (currentAction.Action === ActionType.Pick) {
      pickHero();
      return;
    }
  }

  const selectable = hero.Picked || hero.Banned ? "unselectable" : "selectable";
  return (
    <>
      <Popup
        key={hero.Name}
        header={hero.Name}
        content={
          <h5 className={`tier-${hero.Tier}`} style={{ margin: 0 }}>
            {TierConverter(hero.Tier)} Tier
          </h5>
        }
        mouseEnterDelay={1250}
        position="top center"
        on="hover"
        trigger={
          <div>
            <Transition
              animation="shake"
              duration="1200"
              visible={shakeAnimation}
            >
              <Image
                src={getHeroImage(meleeContext.gameData.GameType, hero)}
                alt={hero.Name}
                className={selectable}
                centered
                style={{ width: 40 }}
                onClick={() => OnClick()}
              />
            </Transition>
          </div>
        }
      />

      {hero.Banned &&
        <Icon size="huge" color="red" name="ban" className="hero-icon" />}
    </>
  );
}

